import { combineReducers } from "redux";

import commonReducer from "./ducks/common/commonReducer";
import authReducer from "./ducks/auth/authReducer";
import photoReducer from "./ducks/photos/photosReducer";
import profileReducer from "./ducks/profile/profileReducer";
import usersReducer from "./ducks/users/usersReducer";
import viewsReducer from "./ducks/views/viewsReducer";
import messagesReducer from "./ducks/messages/messagesReducer";
import pushReducer from "./ducks/push/pushReducer";
import purchaseReducer from "./ducks/purchase/purchaseReducer";
import pinnedReducer from "./ducks/pinned/pinnedReducer";
import feedbackReducer from "./ducks/feedback/feedbackReducer";
import entitiesReducer from "./ducks/entities/entitiesReducer";
import contactsReducer from "./ducks/contacts/contactsReducer";
import bonusReducer from "./ducks/bonus/bonusReducer";

const rootReducer = combineReducers({
  commonReducer,
  authReducer,
  photoReducer,
  profileReducer,
  usersReducer,
  viewsReducer,
  messagesReducer,
  pushReducer,
  purchaseReducer,
  pinnedReducer,
  feedbackReducer,
  entitiesReducer,
  contactsReducer,
  bonusReducer
});

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer;
